module.exports = "/_next/static/images/146ac501ad73fa36b7f05e448feced30-xpeers.jpg.webp";